import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import { useSnackbar } from 'notistack';
import { WEBHOOKS_QUERY_KEY, type DispatchWebhook } from './useDispatchWebhooksQuery';

export interface CreateDispatchWebhookData {
  url: string;
  type: 'slack' | 'teams' | 'discord' | 'generic';
  label?: string;
  scope: 'org' | 'department' | 'user';
  departmentId?: number;
}

export const useCreateDispatchWebhookMutation = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (data: CreateDispatchWebhookData) => {
      const res = await post<DispatchWebhook>('/v1.0/clip-dispatch/webhooks', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WEBHOOKS_QUERY_KEY });
      enqueueSnackbar('Webhook added', { variant: 'success' });
    },
    onError: (error: any) => {
      enqueueSnackbar(error?.response?.data?.error || 'Failed to add webhook', { variant: 'error' });
    },
  });
};
